const Employee = {

    // FIELDS
    "first_name": "First Name",
    "last_name": "Last Name",
    "dob": "Date of Birth",
    "gender": "Gender",
    "father_name": "Father Name",
    "mother_name": "Mother Name",
    "address": "Address",
    "postal_code": "Postal Code",
    "phone_no": "Phone Number",
    "mobile_no": "Mobile Number",
    "status": "Status",
    "country": "Country",
    "state": "State",
    "city": "City",
    "search": "Search",
    "user_type": "User Type",
    "profile": "Profile Image",
    "isUser": "Is User",
    "license_no": "License Number",
    "license_expiry": "License Expiry Date",
    "passport_no": "Passport Number",
    "passport_expiry": "Passport Expiry Date",
    "visa_no": "Visa Number",
    "visa_issue": "Visa Issue Date",
    "visa_expiry": "Visa Expiry Date",
    "email": "Email",
    "basic": "Basic",
    "driver": "Driver",
    "info": "Information",

    // PAGE HEADER
    "employee": "Employee",

    // ERROR
    "error_first_name": "Enter First Name",
    "error_last_name": "Enter Last Name",
    "error_dob": "Choose Date of Birth",
    "error_gender": "Select Gender",
    "error_father_name": "Enter Father Name",
    "error_mother_name": "Enter Mother Name",
    "error_address": "Enter Address",
    "error_postal_code": "Enter Postal Code",
    "error_phone_no": "Enter Phone Number",
    "error_mobile_no": "Enter Mobile Number",
    "error_status": "Select Status",
    "error_country": "Select Country",
    "error_state": "Select State",
    "error_city": "Select City",
    "error_user_type": "Select User Type",
    "error_profile": "Choose Profile",
    "error_isUser": "Switch User",
    "error_license_no": "Enter License Number",
    "error_license_expiry": "Choose License Expiry Date",
    "error_passport_no": "Enter Passport Number",
    "error_passport_expiry": "Choose Passport Expiry Date",
    "error_visa_no": "Enter Visa Number",
    "error_visa_issue": "Choose Visa Issue Date",
    "error_visa_expiry": "Choose Visa Expiry Date",
    "error_email": "Enter Email",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_gender": "GENDER",
    "table_city": "CITY",
    "table_mobile_no": "MOBILE",
    "table_user_type": "USER TYPE",
    "table_is_user": "IS USER",
    "table_status": "STATUS",
}

export default Employee;
